// 因为短信有字符限制，将极短字符放入短信
if(window.location.href.includes('/index/ML')){
    window.location.href = window.location.href.replace('/index/ML','/index/MachineLearning');
}
if(window.location.href.includes('#/AI')){
    window.location.href = window.location.href.replace('/AI','/index/AISSEAI');
}
import Vue from 'vue'
import App from './App.vue'
import router from './routers'
import VueAPI from './api/index'
import ElementUI from 'element-ui';
import store from './store'
// import Mixin from './mixins'

import './common/css/element-variables.scss'
import VueCropper from 'vue-cropper'
import i18n from './lang/index' //国际化
import { transZhEnDynamic } from './utils/transZhEnDynamic'
import authorityObj from './utils/authorityObj'
import LanguageTypeEnum from './enum/LanguageTypeEnum'
import Fingerprint2 from 'fingerprintjs2'; //https://blog.csdn.net/xh1506101064/article/details/107491810
Vue.config.productionTip = false
Vue.use(VueAPI)
Vue.use(ElementUI)
// Vue.mixin(Mixin)
Vue.use(VueCropper)
Vue.prototype.transZhEnDynamic = transZhEnDynamic
Vue.prototype.authorityObj = authorityObj
Vue.prototype.LanguageTypeEnum = LanguageTypeEnum
console.log(i18n.locale)
Vue.prototype.IsNull = value => {
    if (value) {
        return value
    } else {
        if (i18n.locale == 'zh') {
            return '暂无'
        } else {
            return 'Null'
        }
    }
}

// 调用,一般是在main.js或者vuex里面调用
Fingerprint2.get(function (components) {
    const values = components.map(function (component, index) {
        if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
            return component.value.replace(/\bNetType\/\w+\b/, '')
        }
        return component.value
    })
    // 生成最终id murmur 
    //console.log(values)  //使用的浏览器信息
    let murmur = Fingerprint2.x64hash128(values.join(''), 31)
    console.log(murmur) //生成的标识码
    let locarmurmur = localStorage.getItem('Fingerprint2');
    if (!locarmurmur) {
        if (murmur) {
            localStorage.setItem('Fingerprint2', murmur)
        } else {
            localStorage.setItem('Fingerprint2', '')
        }
    }

})


// 自定义修改title
// Vue.directive('title', {//单个修改标题
//     inserted: function (el, binding) {
//         document.title = el.dataset.title
//     }
// })
// 全局样式
import '@/common/css/common.css'
import oss from './assets/oss'
// 全局引入oss文件
Vue.prototype.$oss = oss

new Vue({
    router,
    i18n,
    store,
    render: h => h(App),
}).$mount('#app')
